<template>
  <component v-if="application" :is="app_name" :application="application"></component>
</template>

<script>
import Economics from "@/components/Apps/Economics"
import Forecasting from "@/components/Apps/Forecast/Forecasting"
import VirtualWell from "@/components/Apps/VirtualWell/VirtualWell"
import DucsPermits from "@/components/Apps/DucsPermits/DucsPermits"
import Holdback from "@/components/Apps/Holdback/Holdback"
import Application from "@/api/applications"
export default {
  name: "Application",
  components: {
    Forecasting,
    VirtualWell,
    Holdback,
    Economics,
    DucsPermits
  },
  data() {
    return {
      application: null
    }
  },
  computed: {
    app_name() {
      return `${this.application.view}`
    }
  },
  created() {
    Application.retrieve(this.$route.params.slug).then(response => (this.application = response.data))
  }
}
</script>
